import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Storage } from "@faire/web--source/common/Storage";
import { computed } from "mobx";
export var MakerApplicationDataFormStorage = /*#__PURE__*/ function() {
    "use strict";
    function MakerApplicationDataFormStorage() {
        var _this = this;
        _class_call_check(this, MakerApplicationDataFormStorage);
        this.FORM_DATA_KEY = "MAKER_INBOUND_APPLICATION_FORM_DATA";
        this.initialize = function(defaultData) {
            if (!_this.formData && defaultData) {
                _this.setData(defaultData);
            }
        };
        this.setData = function(data) {
            Storage.local.setItem(_this.FORM_DATA_KEY, JSON.stringify(data));
        };
        this.clearData = function() {
            if (_this.formData) {
                Storage.local.removeItem(_this.FORM_DATA_KEY);
            }
        };
    }
    _create_class(MakerApplicationDataFormStorage, [
        {
            key: "formData",
            get: function get() {
                var data = Storage.local.getItem(this.FORM_DATA_KEY);
                return data ? JSON.parse(data) : undefined;
            }
        }
    ]);
    return MakerApplicationDataFormStorage;
}();
__decorate([
    computed
], MakerApplicationDataFormStorage.prototype, "formData", null);
